import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
	children: ReactNode;
	node?: Element | DocumentFragment | null;
}

/**
 * Portal component that provides a similar API to react-portal
 * but uses React's native createPortal under the hood
 */
export const Portal: React.FC<PortalProps> = ({ children, node }) => {
	// Default to document.body if no node is provided
	const targetElement = node || document.body;

	// Only render if we have a valid target element
	if (!targetElement) {
		return null;
	}

	return createPortal(children, targetElement);
};

export default Portal;
